import { getCurrentUsername } from '@/firebase/auth/authServices';
import { readHabitacion, updateHabitacion } from '@/firebase/firestore/fsServices';
import { createNotification } from '@/firebase/realtimeDB/services';
import { useToast } from "primevue/usetoast";
import { Component, Vue } from 'vue-facing-decorator';
import { useRoute } from 'vue-router';
import router from '@/router/index'
import { findDoctores, findEnfermeros, findDiagnosticos } from '@/firebase/firestore/fsServices';
import { debug } from 'console';

@Component
export default class EditHabitacion extends Vue {
    route = useRoute();
    toast = useToast();

    //local variables
    uid?: any;
    habitacion?: any = {
        medicoTratante: [],
        diagnosticoi: []
    };

    sexos: any[];
    loader: false;
    error: string;
    fecha1: string;
    fecha2: string;
    fecha3: string;
    user: string;

    doctores: any[];
    diagnosticos: any[];
    enfermeros: any[];
    doctoresFilter: any[];
    diagnosticosFilter: any[];
    enfermerosFilter: any[];

    beforeCreate(): void {
        getCurrentUsername().then((username) => {
            this.user = username + "";
        });
    }

    created(): void {
        this.uid = this.route.params.uid;
        readHabitacion(this.uid).then((data) => {
            this.habitacion = data;
            console.log("Habitacion: ", this.habitacion);
            if (!Array.isArray(this.habitacion.medicoTratante)) {
                if (this.habitacion.medicoTratante && typeof this.habitacion.medicoTratante === 'object') {
                    this.habitacion.medicoTratante = [this.habitacion.medicoTratante];
                } else {
                    this.habitacion.medicoTratante = [];
                }
            }
            if (!Array.isArray(this.habitacion.diagnosticoi)) {
                if (this.habitacion.diagnosticoi) {
                    this.habitacion.diagnosticoi = [this.habitacion.diagnosticoi];
                } else {
                    this.habitacion.diagnosticoi = [];
                }
            }

            if (data.fechaing) {
                const date = new Date(data.fechaing);
                this.fecha1 = this.formatDateForInput(date);
            }
            if (data.fechaegr) {
                const date = new Date(data.fechaegr);
                this.fecha2 = this.formatDateForInput(date);
            }
            if (data.fechaNacim) {
                const date = new Date(data.fechaNacim);
                this.fecha3 = this.formatBirthDate(date);
            }
        });
    }

    mounted(): void {
        /* findAllDoctores().then((data) => {
            this.doctores = data;
        }); */
       /*  findAllEnfermeros().then((data) => {
            this.enfermeros = data;
        }); */
        this.sexos = [
            { id: 1, valor: "Masculino" },
            { id: 2, valor: "Femenino" },
        ];
    }

    guardarPaciente() {
        if (this.validatePaciente()) {
            this.formatFechas();
            if (this.habitacion.habitacion.includes("Urgencias") && this.habitacion.status == 0) {
                let notificacion = {
                    content: "Nuevo Paciente Registrado en Urgencias. Se necesita abrir la cuenta del paciente.",
                    timestamp: new Date().getTime(),
                    triggerBy: this.user,
                    status: 1,
                    data: this.habitacion.idHabitacion
                }
                createNotification(notificacion);
            }
            this.habitacion.status = 1;
            // No se modifica, se mantiene el objeto tal cual si ya está bien estructurado
            if (!Array.isArray(this.habitacion.medicoTratante)) {
                if (this.habitacion.medicoTratante && typeof this.habitacion.medicoTratante === 'object') {
                    this.habitacion.medicoTratante = [this.habitacion.medicoTratante];
                } else {
                    this.habitacion.medicoTratante = [];
                }
            }

            if (typeof this.habitacion.nombreEnfermero === 'string') {
                this.habitacion.nombreEnfermero = {nombre:this.habitacion.nombreEnfermero}
            } 
            if (Array.isArray(this.habitacion.diagnosticoi)) {
                this.habitacion.diagnosticoi = this.habitacion.diagnosticoi.map((d: any) => ({ nombre: d.nombre }));
            } else if (this.habitacion.diagnosticoi && typeof this.habitacion.diagnosticoi === 'object') {
                this.habitacion.diagnosticoi = [{ nombre: this.habitacion.diagnosticoi.nombre }];
            } else {
                this.habitacion.diagnosticoi = [];
            }
            console.log("Habitacion: ",this.habitacion)
            updateHabitacion(this.habitacion).then((data) => {
                router.push({ path: "/habitaciones" });
                this.toast.add({ severity: 'success', summary: 'Proceso Exitoso', detail: 'Se actualizó la información del paciente', life: 3600 });
            });
        } else {
            this.toast.add({ severity: 'warn', summary: 'Validación', detail: this.error, life: 3600 });
        }
    }

    async search(event: any) {
        const query = event.query?.trim().toUpperCase() || "";

        if (!query) {
            this.doctoresFilter = [];
            return;
        }

        const resultados = await findDoctores(query);

        const seleccionados = this.habitacion.medicoTratante || [];
        const nombresSeleccionados = new Set(seleccionados.map((d: any) => d.nombre));

        // Solo doctores no seleccionados
        this.doctoresFilter = resultados.filter((d: any) => !nombresSeleccionados.has(d.nombre));
    }

    search2(event: any) {
        setTimeout(async () => {
            if (!event.query.trim().length) {
                this.enfermerosFilter = [];
            } else {
                let busqueda = event.query.toUpperCase().trim();
                this.enfermerosFilter = await findEnfermeros(busqueda);
                
            }
        });
    }

    
    async search3(event: any) {
        const query = event.query?.trim().toUpperCase() || "";

        if (!query) {
            this.diagnosticosFilter = [];
            return;
        }

        const resultados = await findDiagnosticos(query);
        const seleccionados = this.habitacion.diagnosticoi || [];
        const seleccionadosNombres = new Set(seleccionados.map((d: any) => d.nombre));

        this.diagnosticosFilter = resultados.filter((d: any) => !seleccionadosNombres.has(d.nombre));
    }


    //onChangeDoctor(event: any) {
      //  this.habitacion.medicoTratante = this.habitacion.medicoTratante.nombre;
    //}
    //onChangeDiag(event: any){
      //  this.habitacion.diagnosticoi = this.habitacion.diagnosticoi.nombre
    //}
    onChangeEnfermero(event: any) {
        console.log(event)
        //this.habitacion.nombreEnfermero = this.habitacion.nombreEnfermero.nombre;
    }

    private formatFechas() {
        if (this.fecha1) {
            var fechaIngreso = new Date(this.fecha1);
            this.habitacion.fechaing = fechaIngreso.getTime();
        }
        if (this.fecha3) {
            debugger
            var fechaNacim = new Date(this.fecha3);
            //a la fecha le añadimos 8 horas
            fechaNacim.setHours(fechaNacim.getHours() + 8);
            fechaNacim.setDate(fechaNacim.getDate());
            this.habitacion.fechaNacim = fechaNacim.getTime();
            //this.habitacion.fechaNacim += 14 * 60 * 60 * 1000;
            console.log("Fecha Nacimiento: ", this.habitacion.fechaNacim)
        }
        if (this.fecha2) {
            var fechaEgreso = new Date(this.fecha2);
            this.habitacion.fechaegr = fechaEgreso.getTime();
        }
    }

    private formatDateForInput(date: Date, dateOnly: boolean = false): string {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        
        if (dateOnly) {
            return `${year}-${month}-${day}`;
        }
        
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        return `${year}-${month}-${day}T${hours}:${minutes}`;
    }

    private formatBirthDate(date: Date): string {
        const adjustedDate = new Date(date);
        //adjustedDate.setDate(adjustedDate.getDate() + 1);
        const year = adjustedDate.getFullYear();
        const month = String(adjustedDate.getMonth() + 1).padStart(2, '0');
        const day = String(adjustedDate.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    }

    private validatePaciente() {
        if (this.habitacion.nombrePaciente == null) {
            this.error = "El nombre del paciente no puede estar vacío";
            return false;
        }
        if (this.habitacion.edad == null) {
            this.error = "La edad no puede estar vacía";
            return false;
        }
        if (this.habitacion.direccion == null) {
            this.error = "La dirección no puede estar vacía";
            return false;
        }
        if (this.habitacion.tel == null) {
            this.error = "El telefono no puede estar vacio";
            return false;
        }
        if (this.habitacion.correo == null) {
            this.error = "El correo no puede estar vacio";
            return false;
        }
        if (this.fecha1 == null) {
            this.error = "La fecha de ingreso no puede estar vacía";
            return false;
        }
        if (this.fecha3 == null) {
            this.error = "La fecha de nacimiento no puede estar vacía";
            return false;
        }
        if (this.habitacion.diagnosticoi == null) {
            this.error = "El Diagnóstico iniciar no puede esta vacío";
            return false;
        }
        if (this.habitacion.medicoTratante == null) {
            this.error = "El nombre del médico no puede estar vacío";
            return false;
        }
        if (this.habitacion.isalergia && this.habitacion.alergias == null) {
            return false;
        }
        return true;
    }

}